import React from 'react';
import {
  faChevronDown,
  faChevronUp
} from '@fortawesome/pro-solid-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import FaqPanelBody from './FaqPanelBody';

const FaqPanel = ({ faq, isSearch, searchVal }) => {
  var filteredFaq = faq.filter(
    item =>
      JSON.stringify(item.title)
        .toLowerCase()
        .includes(searchVal && searchVal.toLowerCase()) ||
      JSON.stringify(item.info)
        .toLowerCase()
        .includes(searchVal && searchVal.toLowerCase())
  );

  const faqDisplayed = isSearch ? filteredFaq : faq;
  return faqDisplayed.map((panel, index) => (
    <div
      key={`faq-item${index}`}
      className={
        index === faq.length - 1
          ? 'faq__panel faq__panel--last'
          : 'faq__panel'
      }>
      <div
        className={
          isSearch && searchVal
            ? 'mini-faq__heading'
            : 'mini-faq__heading collapsed'
        }
        data-toggle="collapse"
        href={`#fleetFaq${index + 1}`}>
        <h4 className="mini-faq__panel--title mini-faq__panel--title--nyc">
          {panel.title}
        </h4>
        <FontAwesomeIcon
          className="mini-faq__arrow"
          icon={faChevronDown}
        />
      </div>
      {isSearch && searchVal ? (
        <div id={`fleetFaq${index + 1}`} className="collapse in">
          <FaqPanelBody content={panel.info} />
        </div>
      ) : (
        <div id={`fleetFaq${index + 1}`} className="collapse">
          <FaqPanelBody content={panel.info} />
        </div>
      )}
    </div>
  ));
};

export default FaqPanel;



// WEBPACK FOOTER //
// ./src/components/Static/SFFleets/Shared/FaqPanel.js